var map = {
	"./img-1.png": 6581,
	"./img-10.png": 6128,
	"./img-11.png": 2659,
	"./img-12.png": 8381,
	"./img-13.png": 4805,
	"./img-14.png": 4930,
	"./img-15.png": 7994,
	"./img-16.png": 4120,
	"./img-17.png": 9506,
	"./img-18.png": 4373,
	"./img-19.png": 5458,
	"./img-2.png": 7787,
	"./img-20.png": 8803,
	"./img-3.png": 1136,
	"./img-4.png": 4890,
	"./img-5.png": 5806,
	"./img-6.png": 6279,
	"./img-7.png": 7656,
	"./img-8.png": 3151,
	"./img-9.png": 9848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5635;